// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pyramid-Board {
  display: grid;
  grid-template-columns: 74vw auto;
  gap: 2.5vw;
  margin-top: 2vh;
}
.Pyramid-Scene {
  display: grid;
  position: relative;
  place-items: center;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border: 2px solid #1a6a7c;
}
.Pyramid-BackgroundImg {
  width: 100%;
}
.Pyramid-A {
  bottom: 9%;
  left: 11%;
}
.Pyramid-B {
  bottom: 16%;
}
.Pyramid-C {
  bottom: 9%;
  right: 12%;
}
.Pyramid-A.acrobat {
  bottom: 4%;
  left: 17%;
}
.Pyramid-B.acrobat {
  bottom: 9%;
}
.Pyramid-C.acrobat {
  bottom: 4%;
  right: 17%;
}
.Pyramid-console.run {
  font-family: Consolas;
  height: auto;
  width: auto;
  background: white;
  overflow: auto;
  border: 1px solid #ccc;
  padding: 5px;
}

.Pyramid-program-line {
  padding: 2px 5px;
  margin: 1px 0;
  border-left: 3px solid transparent;
}

.Pyramid-program-line.current-line {
  background-color: rgb(181, 234, 255);
}

.Pyramid-program-line.error-line {
  background-color: rgb(255, 159, 159);
}

.Pyramid-console {
  font-family: Consolas;
  max-height: 82.5vh;
  width: auto;
  border: solid 1px;
  font-size: 1.5vw;
  padding: 10px;
  overflow-y: scroll;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-color: rgb(0, 58, 94);
  resize: none;
  color: rgb(0, 58, 94);
}

.Pyramid-Management-bar {
  display: grid;
}
.Pyramid-platform {
  position: absolute;
  height: 30vw;
  width: 10vw;
  display: flex;
  flex-direction: column-reverse; /* ← Ключевое изменение! */
  align-items: center;
  justify-content: flex-start; /* Меняем на flex-start */
  gap: 0;
  padding-bottom: 10px;
}
.Pyramid-character {
  position: relative;
}
.Pyramid-case-character-4 {
  height: 6.4vw;
}
.Pyramid-case-character-3 {
  height: 8.4vw;
}
.Pyramid-case-character-2 {
  height: 5.5vw;
}
.Pyramid-case-character-1 {
  height: 10vw;
}
.Pyramid-size-1 {
    bottom: 1vh;
    left: 3vw;
    height: 11.5vw;
}
.Pyramid-size-2 {
  bottom: 1vh;
  height: 7vw;
}
.Pyramid-size-3 {
  height: 9vw;
  left: 1vw;
}
.Pyramid-size-4 {
  height: 7vw;
  left: 2.5vw;
}

.Pyramid-winbackground {
  width: 100%;
  animation: fadeIn 1s ease;
  position: absolute;
  align-self: flex-start;
}

.Pyramid-size-1.acrobat {
    bottom: 1vw;
    height: 15.5vw;
    left: -0.5vh;
}
.Pyramid-size-2.acrobat {
    bottom: 0.2vw;
    height: 13vw;
}
.Pyramid-size-3.acrobat {
    bottom: 0.6vw;
    height: 8vw;
    left: 0vw;
}
.Pyramid-size-4.acrobat {
    height: 8vw;
    left: -0.6vh;
}

.Pyramid-case-character-4.acrobat {
  height: 6.1vw;
}
.Pyramid-case-character-3.acrobat {
  height: 6vw;
}
.Pyramid-case-character-2.acrobat {
  height: 9vw;
}
.Pyramid-case-character-1.acrobat {
    height: 13.5vw;
}
.win-pers{
      left: 3.5vw;
    bottom: 1vw;
    height: 8vw;
}
.Pyramid-character.fade-in {
  animation: fadeIn 0.5s ease-out forwards;
}

.Pyramid-character.fade-out {
  animation: fadeOut 0.5s ease-in forwards;
}


@keyframes fadeOut {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.6);
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/PyramidApp/styles/PyramidBoard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gCAAgC;EAChC,UAAU;EACV,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,4EAA4E;EAC5E,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,UAAU;AACZ;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,4EAA4E;EAC5E,4BAA4B;EAC5B,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,8BAA8B,EAAE,0BAA0B;EAC1D,mBAAmB;EACnB,2BAA2B,EAAE,yBAAyB;EACtD,MAAM;EACN,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;IACI,WAAW;IACX,SAAS;IACT,cAAc;AAClB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,YAAY;AAChB;AACA;IACI,aAAa;IACb,YAAY;AAChB;AACA;IACI,aAAa;IACb,WAAW;IACX,SAAS;AACb;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;IACI,cAAc;AAClB;AACA;MACM,WAAW;IACb,WAAW;IACX,WAAW;AACf;AACA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".Pyramid-Board {\n  display: grid;\n  grid-template-columns: 74vw auto;\n  gap: 2.5vw;\n  margin-top: 2vh;\n}\n.Pyramid-Scene {\n  display: grid;\n  position: relative;\n  place-items: center;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  border: 2px solid #1a6a7c;\n}\n.Pyramid-BackgroundImg {\n  width: 100%;\n}\n.Pyramid-A {\n  bottom: 9%;\n  left: 11%;\n}\n.Pyramid-B {\n  bottom: 16%;\n}\n.Pyramid-C {\n  bottom: 9%;\n  right: 12%;\n}\n.Pyramid-A.acrobat {\n  bottom: 4%;\n  left: 17%;\n}\n.Pyramid-B.acrobat {\n  bottom: 9%;\n}\n.Pyramid-C.acrobat {\n  bottom: 4%;\n  right: 17%;\n}\n.Pyramid-console.run {\n  font-family: Consolas;\n  height: auto;\n  width: auto;\n  background: white;\n  overflow: auto;\n  border: 1px solid #ccc;\n  padding: 5px;\n}\n\n.Pyramid-program-line {\n  padding: 2px 5px;\n  margin: 1px 0;\n  border-left: 3px solid transparent;\n}\n\n.Pyramid-program-line.current-line {\n  background-color: rgb(181, 234, 255);\n}\n\n.Pyramid-program-line.error-line {\n  background-color: rgb(255, 159, 159);\n}\n\n.Pyramid-console {\n  font-family: Consolas;\n  max-height: 82.5vh;\n  width: auto;\n  border: solid 1px;\n  font-size: 1.5vw;\n  padding: 10px;\n  overflow-y: scroll;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  border-color: rgb(0, 58, 94);\n  resize: none;\n  color: rgb(0, 58, 94);\n}\n\n.Pyramid-Management-bar {\n  display: grid;\n}\n.Pyramid-platform {\n  position: absolute;\n  height: 30vw;\n  width: 10vw;\n  display: flex;\n  flex-direction: column-reverse; /* ← Ключевое изменение! */\n  align-items: center;\n  justify-content: flex-start; /* Меняем на flex-start */\n  gap: 0;\n  padding-bottom: 10px;\n}\n.Pyramid-character {\n  position: relative;\n}\n.Pyramid-case-character-4 {\n  height: 6.4vw;\n}\n.Pyramid-case-character-3 {\n  height: 8.4vw;\n}\n.Pyramid-case-character-2 {\n  height: 5.5vw;\n}\n.Pyramid-case-character-1 {\n  height: 10vw;\n}\n.Pyramid-size-1 {\n    bottom: 1vh;\n    left: 3vw;\n    height: 11.5vw;\n}\n.Pyramid-size-2 {\n  bottom: 1vh;\n  height: 7vw;\n}\n.Pyramid-size-3 {\n  height: 9vw;\n  left: 1vw;\n}\n.Pyramid-size-4 {\n  height: 7vw;\n  left: 2.5vw;\n}\n\n.Pyramid-winbackground {\n  width: 100%;\n  animation: fadeIn 1s ease;\n  position: absolute;\n  align-self: flex-start;\n}\n\n.Pyramid-size-1.acrobat {\n    bottom: 1vw;\n    height: 15.5vw;\n    left: -0.5vh;\n}\n.Pyramid-size-2.acrobat {\n    bottom: 0.2vw;\n    height: 13vw;\n}\n.Pyramid-size-3.acrobat {\n    bottom: 0.6vw;\n    height: 8vw;\n    left: 0vw;\n}\n.Pyramid-size-4.acrobat {\n    height: 8vw;\n    left: -0.6vh;\n}\n\n.Pyramid-case-character-4.acrobat {\n  height: 6.1vw;\n}\n.Pyramid-case-character-3.acrobat {\n  height: 6vw;\n}\n.Pyramid-case-character-2.acrobat {\n  height: 9vw;\n}\n.Pyramid-case-character-1.acrobat {\n    height: 13.5vw;\n}\n.win-pers{\n      left: 3.5vw;\n    bottom: 1vw;\n    height: 8vw;\n}\n.Pyramid-character.fade-in {\n  animation: fadeIn 0.5s ease-out forwards;\n}\n\n.Pyramid-character.fade-out {\n  animation: fadeOut 0.5s ease-in forwards;\n}\n\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(0.6);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: scale(0.6);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
